async function devtricker_deletePost(postId) {
    try {
        await devtricker_ajax_post_delete(postId);
        return true;
    } catch (err) {
        devtricker_showPostToast(devtricker_createErrorToast('top', 10, err.message));
    }
}

async function devtricker_confirmPostDeletion(postId) {
    if (confirm("Are you sure you want to delete this post?")) {
        const success = await devtricker_deletePost(postId);
        if (success) {
            window.location.reload();
        }
    }
}

async function devtricker_devtricker_confirmPostDeletionRedirectHome() {
    if (confirm("Are you sure you want to delete this post?")) {

        const postId = devtricker_getThePostId();
        const success = await devtricker_deletePost(postId);
        if (success) {
            window.location.href = '/';
        }
    }
}